export const GET_ALL_CASES = "GET_ALL_CASES";
export const SET_ALL_CASES = "SET_ALL_CASES";
export const GET_CLOSED_CASES = "GET_CLOSED_CASES";
export const SET_CLOSED_CASES = "SET_CLOSED_CASES";
export const CLEAR_CLOSED_CASES = "CLEAR_CLOSED_CASES";
export const SET_FILTERED_CASELIST = "SET_FILTERED_CASELIST";
export const SET_CASES_PER_PAGE = "SET_CASES_PER_PAGE";
export const SET_VIEW_CASES_LOADER = "SET_VIEW_CASES_LOADER";
export const SET_CASES_ACTIVE_PAGE = "SET_CASES_ACTIVE_PAGE";
export const SET_CASES_TOTAL_NUMBER_OF_RECORDS = "SET_CASES_TOTAL_NUMBER_OF_RECORDS";
export const SET_FROM_DATE = "SET_FROM_DATE";
export const SET_TO_DATE = "SET_TO_DATE";
export const SET_APPLIED_FROM_DATE = "SET_APPLIED_FROM_DATE";
export const SET_APPLIED_TO_DATE = "SET_APPLIED_TO_DATE";
export const SET_SEARCH_INPUT = "SET_SEARCH_INPUT";
export const SET_SEARCH_BASED_ON = "SET_SEARCH_BASED_ON";
export const SET_STATUS = "SET_STATUS";
export const SET_APPLIED_STATUS = "SET_APPLIED_STATUS";
export const VIEW_CASES_RESET = "VIEW_CASES_RESET";
export const TOGGLE_CREATE_CASE = "TOGGLE_CREATE_CASE";
export const SET_CASE_STATUS = "SET_CASE_STATUS";
export const SET_CASE_CREATED_SUCCESS = "SET_CASE_CREATED_SUCCESS";
export const HANDLE_CASE_FILTER = "HANDLE_CASE_FILTER";
export const SET_IS_ERROR = "SET_IS_ERROR";
export const SET_DATE_FORMAT = "SET_DATE_FORMAT";

export function getAllCases() {
  return {
    type: GET_ALL_CASES,
  };
}

export function setAllCases(response) {
  return {
    type: SET_ALL_CASES,
    response,
  };
}

export function getClosedCases(callBack) {
  return {
    type: GET_CLOSED_CASES,
    callBack,
  };
}

export function clearClosedCases() {
  return {
    type: CLEAR_CLOSED_CASES,
  };
}

export function setClosedCases(response) {
  return {
    type: SET_CLOSED_CASES,
    response,
  };
}

export function setFilteredCaseList(value) {
  return {
    type: SET_FILTERED_CASELIST,
    value,
  };
}

export function setCasesPerPage(value) {
  return {
    type: SET_CASES_PER_PAGE,
    value,
  };
}

export function setLoader(value) {
  return {
    type: SET_VIEW_CASES_LOADER,
    value,
  };
}

export function setActivePage(value) {
  return {
    type: SET_CASES_ACTIVE_PAGE,
    value,
  };
}

export function setTotalNumberOfRecords(value) {
  return {
    type: SET_CASES_TOTAL_NUMBER_OF_RECORDS,
    value,
  };
}

export function setFromDate(value) {
  return {
    type: SET_FROM_DATE,
    value,
  };
}

export function setToDate(value) {
  return {
    type: SET_TO_DATE,
    value,
  };
}

export function setAppliedFromDate(value) {
  return {
    type: SET_APPLIED_FROM_DATE,
    value,
  };
}

export function setAppliedToDate(value) {
  return {
    type: SET_APPLIED_TO_DATE,
    value,
  };
}

export function setSearchInput(value) {
  return {
    type: SET_SEARCH_INPUT,
    value,
  };
}

export function setSearchBasedOn(value) {
  return {
    type: SET_SEARCH_BASED_ON,
    value,
  };
}

export function setStatus(value) {
  return {
    type: SET_STATUS,
    value,
  };
}

export function setAppliedStatus(value) {
  return {
    type: SET_APPLIED_STATUS,
    value,
  };
}

export function reset() {
  return {
    type: VIEW_CASES_RESET,
  };
}

export function toggleCreateCase(value) {
  return {
    type: TOGGLE_CREATE_CASE,
    value,
  };
}

export function setCaseStatus(response) {
  return {
    type: SET_CASE_STATUS,
    response,
  };
}

export function setCaseCreatedSuccess(value) {
  return {
    type: SET_CASE_CREATED_SUCCESS,
    value,
  };
}

export function handleCaseFilter(input, searchfield, fromDate, toDate, statusVal) {
  return {
    type: HANDLE_CASE_FILTER,
    input,
    searchfield,
    fromDate,
    toDate,
    statusVal,
  };
}
export function setIsError(value) {
  return {
    type: SET_IS_ERROR,
    value,
  };
}
export function setDateFormat(value) {
  return {
    type: SET_DATE_FORMAT,
    value,
  };
}
